module.exports = __webpack_public_path__ + "img/imagen1.a7dc85fd.png";